module.exports = __webpack_public_path__ + "img/h-3-about-3-left-mobile.d7d2ab26.png";